"use strict";
import Barba from "barba.js";
import Env from "../base/env.js";
import Channels from "../base/channels";
import * as Buttons from "../components/buttons";
import "babel-polyfill";
import TypeWriter from "../components/about/TypeWriter";
import Mailto from "../components/Mailto";
import WorkspaceGrid from "../components/works/Grid";
import raf from "raf";
import FlowWaypoints from "../components/FlowWaypoints";

let page;

class Page {
  constructor(view = "") {
    this.view = view;
    this.classView = "currentView--home";
    this.$grid = this.view.querySelector(".jsGrid--view");
    this.$gridItems = this.$grid.querySelectorAll(".jsItem");
    this.DOM = {
      videoContainer: this.view.querySelector(".jsVideoContainer"),
      progressBar: this.view.querySelector(".jsProgressBar"),
      btnSound: this.view.querySelector(".jsBtnSound"),
    };
    this.catchphrases = this.view.querySelector(".jsData").value.split("[=]");
    if (Env.mobileCSS == true) {
      this.DOM.videoContainer.removeChild(
        this.DOM.videoContainer.querySelector(".video-desktop")
      );
    } else {
      this.DOM.videoContainer.removeChild(
        this.DOM.videoContainer.querySelector(".video-mobile")
      );
    }
    this.raf = undefined;
    // Fns
    this.workspaceGrid = new WorkspaceGrid(this);
    new Mailto(this.view);
    // Fns
    // this.slideshow = new HomeSlideshow(this.view.querySelector('.jsHomeSlideshow--view'))
    this.events();
    // Launch Fn
    this.funcLaunch = this.intro.bind(this);
    if (Env.framework.UI.launcher.LAUNCHED == false) this.channels();
  }

  channels() {
    Channels.on("launcher::exit", this.funcLaunch);
  }

  destroy() {
    raf.cancel(this.raf);
    Channels.removeListener("launcher::exit", this.funcLaunch);
    this.workspaceGrid.destroy();
    this.waypoints.destroy();
  }

  events() {
    Buttons.hoverCta1(this.view);
  }

  finalize() {
    this.watcher();
    setTimeout(() => {
      if (Env.isVisiting === true) {
        this.intro();
      }
      this.waypoints = new FlowWaypoints(this.view);
      this.workspaceGrid.enableMousemove();
      this.typewriter = new TypeWriter(this.view, this.catchphrases);
      this.typewriter.animation();
    }, 200);
  }

  intro() {
    let timeline = new TimelineLite();

    const $fill = this.view.querySelector(".fxFill");

    timeline.add([
      TweenLite.fromTo(
        $fill,
        1.2,
        { opacity: 1 },
        {
          opacity: 0,
          ease: Cubic.easeInOut,
          onStart: () => {
            TweenLite.delayedCall(1, () => {
              this.startVideo();
            });
          },
        }
      ),
    ]);
  }

  startVideo() {
    const videos = this.DOM.videoContainer.querySelectorAll("video");
    for (let video of videos) {
      video.play();
      video.addEventListener("timeupdate", () => {
        const total = video.duration;
        const progression = video.currentTime / total;
        TweenLite.set(this.DOM.progressBar, { scaleY: progression });
      });
      this.DOM.btnSound.addEventListener("click", () => {
        video.muted = !video.muted;
        this.DOM.btnSound.classList.toggle("is-active");
      });
    }
  }

  watcher() {
    this.raf = raf(() => {
      this.watcher();
    });
    this.workspaceGrid.onWatch();
  }
}

page = Barba.BaseView.extend({
  namespace: "home",
  node: undefined,
  onEnter: function () {
    this.node = new Page(this.container);
    Env.$html.classList.add(this.node.classView);
  },
  onEnterCompleted: function () {
    this.node.finalize();
  },
  onLeave: function () {
    this.node.destroy();
  },
  onLeaveCompleted: function () {
    if (this.container.getAttribute("data-namespace") != this.namespace) {
      Env.$html.classList.remove(this.node.classView);
    }
  },
});

export default page;
